//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CountryDescription from '~/components/countryGuides/CountryDescription.vue'
import CountryFeaturesCostaRica from '~/components/countryGuides/CountryFeaturesCostaRica.vue'
import CountryPaymentCardCostaRica from '~/components/countryGuides/CountryPaymentCardCostaRica.vue'
import CountryTop from '~/components/countryGuides/CountryTop.vue'
import FooterTop from '~/components/footer/footerTop.vue'
export default {
  components: {
    CountryTop,
    CountryPaymentCardCostaRica,
    CountryDescription,
    CountryFeaturesCostaRica,
    FooterTop
  },
  head () {
    return {
      title: this.$t('footer.markets.cr').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  }
}
